window.addEventListener('load', () => {
  for (const el of document.getElementsByTagName('audio')) {
    if (!el.classList.contains("stream")) {
      el.setAttribute('preload', 'metadata');
    }
  }
});
